module.exports = __webpack_public_path__ + "img/content01.d9a3fda3.png";